import { FiPhone, FiMapPin, FiMail } from 'react-icons/fi'
import { FaFacebookF, FaLinkedinIn, FaInstagram } from 'react-icons/fa'
import './Footer.css'

// ── Types ──────────────────────────────────────────────────────────────────

interface NavLink { label: string; href: string }
interface ContactItem { icon: React.ReactNode; label: string; value: React.ReactNode }

// ── Data ───────────────────────────────────────────────────────────────────

const servicos: NavLink[] = [
  { label: 'Seguro Auto', href: '#servicos' },
  { label: 'Seguro de Saúde', href: '#servicos' },
  { label: 'Seguro de Vida', href: '#servicos' },
  { label: 'Seguro Empresarial', href: '#servicos' },
  { label: 'Seguro de Habitação', href: '#servicos' },
]

const empresa: NavLink[] = [
  { label: 'Início', href: '#inicio' },
  { label: 'Serviços', href: '#servicos' },
  { label: 'Sobre Nós', href: '#sobre-nos' },
  { label: 'Clientes', href: '#clientes' },
  { label: 'Parceiros', href: '#parceiros' },
  { label: 'Contactos', href: '#contactenos' },
];

const socials = [
  { label: 'Facebook', icon: <FaFacebookF size={13} />, url: 'https://web.facebook.com/profile.php?id=61552485801171' },
  { label: 'LinkedIn', icon: <FaLinkedinIn size={13} />, url: 'https://www.linkedin.com/company/makhowo-corretores-de-seguros/?viewAsMember=true' },
  { label: 'Instagram', icon: <FaInstagram size={13} />, url: 'https://www.instagram.com/makhowo.cs/' },
]

// ── Helpers ────────────────────────────────────────────────────────────────

const scrollTo = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
  e.preventDefault()
  const sectionId = href.replace('#', '')
  if (window.location.pathname === '/') {
    const el = document.getElementById(sectionId)
    if (el) el.scrollIntoView({ behavior: 'smooth' })
  } else {
    window.location.href = `/#${sectionId}`
  }
}

// ── Sub-components ─────────────────────────────────────────────────────────

const NavColumn = ({ title, links }: { title: string; links: NavLink[] }) => (
  <div className="ft-col">
    <p className="ft-col-title">{title}</p>
    <ul className="ft-col-list">
      {links.map(({ label, href }) => (
        <li key={label}>
          <a href={href} onClick={e => scrollTo(e, href)} className="ft-link">{label}</a>
        </li>
      ))}
    </ul>
  </div>
)

const ContactRow = ({ icon, label, value }: ContactItem) => (
  <div className="ft-contact-row">
    <span className="ft-contact-icon">{icon}</span>
    <div className="ft-contact-text">
      <span className="ft-contact-label">{label}</span>
      <span className="ft-contact-value">{value}</span>
    </div>
  </div>
)

// ── Footer ─────────────────────────────────────────────────────────────────

export default function Footer() {
  return (
    <footer id="footer" className="footer">

      {/* ── Decorative top rule ─────────────────── */}
      <div className="footer-top-rule">
        <span className="footer-rule-line" />
        <span className="footer-rule-line" />
      </div>

      {/* ── Main body ───────────────────────────── */}
      <div className="footer-body">
        <div className="ft-grid">

          {/* Brand */}
          <div className="ft-col ft-brand">
            <a href="#inicio" className="ft-logo-link" onClick={e => scrollTo(e, '#inicio')}>
              <img src="/logo.png" alt="Makhowo Seguros" className="ft-logo" />
            </a>
            <p className="ft-tagline">
              Protegemos o que mais importa,<br />
              com <em>confiança</em> e dedicação.
            </p>
            <div className="ft-socials">
              {socials.map(({ label, icon, url }) => (
                <a
                  key={label}
                  href={url}
                  className="ft-social"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={label}
                >
                  {icon}
                </a>
              ))}
            </div>
          </div>

          <NavColumn title="Serviços" links={servicos} />
          <NavColumn title="Empresa" links={empresa} />

        </div>
      </div>

      {/* ── Bottom bar ──────────────────────────── */}
      <div className="footer-bottom">
        <div className="footer-bottom-rule" />
        <div className="footer-bottom-inner">

          <p className="footer-copy">
            © {new Date().getFullYear()} Makhowo Seguros. Todos os direitos reservados.
          </p>

          <nav className="footer-legal" aria-label="Legal">
            <a href="#" className="footer-legal-link">Política de Privacidade</a>
            <span className="footer-legal-dot" aria-hidden="true" />
            <a href="#" className="footer-legal-link">Termos de Uso</a>
            <span className="footer-legal-dot" aria-hidden="true" />
            <a href="#" className="footer-legal-link">Cookies</a>
          </nav>

        </div>
      </div>

    </footer>
  )
}